import ExpertController from './expert.controller';
import template from './expert.html';
import './expert.less';

const ExpertContainer = {
  bindings: {},
  template,
  controller: ExpertController
};

export default ExpertContainer;



// WEBPACK FOOTER //
// ./src/containers/expert/expert.component.js